(function () {
    'use strict';

    function informationPartQuestion($rootScope, $timeout, notifyService) {

        return {
            restrict: 'E',
            templateUrl: 'common/directives/templates/informationPartQuestion.html',
            scope: {
                questionData: '=',
                editorMode: '=?',
                canDelete: '=',
                removeQuestion: '&',
                syncQuestion: '&',
                reorderMode: '=',
                access: '='
            },
            link: function (scope, element, attrs) {
                if (!attrs.mode) {
                    scope.editorMode = 'Editor';
                }

                scope.titleContext = '';
                scope.editTitleData = {
                    Title: '',
                    OriginalTitle: ''
                };

                scope.siblingNames = [];

                scope.workflowTitleMode = scope.access.Edit ? 'display': 'readonly';
                scope.editTitleData.Title = scope.questionData.Prompt;

                scope.editWorkflowTitle = function () {
                    scope.workflowTitleMode = 'edit';
                    scope.editTitleData.OriginalTitle = scope.editTitleData.Title;
                }

                scope.saveWorkflowTitle = function () {
                    scope.questionData.Prompt = scope.editTitleData.Title;
                    scope.syncQuestion();
                    scope.editTitleData.OriginalTitle = scope.editTitleData.Title;
                    scope.workflowTitleMode = 'display';
                    notifyService.notify('The ' + scope.titleContext + ' title has been updated');
                }

                scope.cancelSaveWorkflowTitle = function () {
                    scope.workflowTitleMode = 'display';
                    scope.editTitleData.Title = scope.editTitleData.OriginalTitle;
                }
                
                scope.editQuestionPromptModel = {
                    Prompt: scope.questionData.Prompt
                }

                scope.editQuestionContentModel = angular.copy(scope.questionData);

                scope.toggleEditQuestionPrompt = function (save) {
                    if (save) {
                        // wait until changes propagate
                        $timeout(function () {
                            scope.questionData.Prompt = scope.editQuestionPromptModel.Prompt;
                            scope.syncQuestion();
                        }, 0);
                    }
                    else {
                        scope.editQuestionPromptModel.Prompt = scope.questionData.Prompt;
                    }

                    scope.editingQuestionPrompt = !scope.editingQuestionPrompt;
                }

                scope.toggleEditQuestionContent = function (save) {
                    if (save) {
                        // wait until changes propagate
                        $timeout(function () {
                            if (scope.editQuestionContentModel.Options) {
                                scope.questionData.Options =
                                    scope.editQuestionContentModel.Options.map(
                                        function (option) {
                                            return {
                                                Title: option.Title,
                                                Prompt: option.Prompt,
                                                IsSelected: option.IsSelected
                                            }
                                        }
                                    );
                            }
                            scope.syncQuestion();
                        }, 0);
                    }
                    else {
                        scope.editQuestionContentModel = angular.copy(scope.questionData);
                    }

                    scope.editingQuestionContent = !scope.editingQuestionContent;
                }

                scope.addOptionToQuestion = function () {
                    scope.editQuestionContentModel.Options.push({
                        Title: 'New Option',
                        Prompt: 'New Option',
                        IsSelected: false
                    });
                }

                scope.removeOptionFromQuestion = function (optionIndex) {
                    scope.editQuestionContentModel.Options.splice(optionIndex, 1);
                }

                scope.canReorder = false;

                scope.optionExists = function (optionPrompt) {
                    return scope.questionData.Options.find(function (option) {
                        return option.Prompt === optionPrompt && option.IsSelected;
                    });
                };

                scope.toggleOption = function(optionPrompt) {
                    var matchingOption = scope.questionData.Options.find(function (option) {
                        return option.Prompt === optionPrompt });
                    matchingOption.IsSelected = !matchingOption.IsSelected;
                }

                $rootScope.$watch(function () { return scope.reorderMode },
                        function (newVal) { scope.canReorder = newVal; });
            }
        };
    }

    informationPartQuestion.$inject = ['$rootScope', '$timeout', 'notifyService'];

    angular.module('ecap.common').directive('informationPartQuestion', informationPartQuestion);
})();

